module.exports = __webpack_public_path__ + "img/image.ede3c80.png";